import { useEffect } from "react"
import Loading from "components/ui/Loading"

const HardReload = () => {
  useEffect(() => {
    window.location.reload()
  })

  return <Loading />
}

export default HardReload
